import { lazy, Suspense, type ReactNode } from "react";

import { usePrivacySessionStore } from "@/modules/mine/privacy/store";
import { ItemDetailPageLoading } from "@/pages/item-detail/loading";
import { FlowDetailPageLoading } from "@/pages/mine/flow/detail-loading";
import { FlowPageLoading } from "@/pages/mine/flow/loading";
import { PluginsPageLoading } from "@/pages/mine/plugins/loading";
import { TrashPageLoading } from "@/pages/mine/trash/loading";
import { ImageLightboxProvider } from "@/shared/components/image-lightbox";

import { RouteLoading } from "./route-loading";

const ErrorPage = lazy(() => import("@/pages/error"));
const HomePage = lazy(() => import("@/pages/home"));
const ItemDetailPage = lazy(() => import("@/pages/item-detail"));
const OnboardingPage = lazy(() => import("@/pages/onboarding"));
const PricingPage = lazy(() => import("@/pages/pricing"));
const EducationPage = lazy(() => import("@/pages/education"));
const MineFlowPage = lazy(() => import("@/pages/mine/flow"));
const MineFlowDetailPage = lazy(() => import("@/pages/mine/flow/detail"));
const MinePluginsPage = lazy(() => import("@/pages/mine/plugins"));
const MineTrashPage = lazy(() => import("@/pages/mine/trash"));

function withRouteSuspense(node: ReactNode) {
  return <Suspense fallback={<RouteLoading />}>{node}</Suspense>;
}

export function ErrorRoutePage() {
  return withRouteSuspense(<ErrorPage />);
}

export function HomeRoutePage() {
  return withRouteSuspense(<HomePage />);
}

export function ItemDetailRoutePage() {
  const lockVersion = usePrivacySessionStore((state) => state.lockVersion);
  return (
    <ImageLightboxProvider resetSignal={lockVersion}>
      <Suspense fallback={<ItemDetailPageLoading />}>
        <ItemDetailPage />
      </Suspense>
    </ImageLightboxProvider>
  );
}

export function PricingRoutePage() {
  return withRouteSuspense(<PricingPage />);
}

export function EducationRoutePage() {
  return withRouteSuspense(<EducationPage />);
}

export function OnboardingRoutePage() {
  return withRouteSuspense(<OnboardingPage />);
}

export function MineFlowRoutePage() {
  return <Suspense fallback={<FlowPageLoading />}><MineFlowPage /></Suspense>;
}

export function MineFlowDetailRoutePage() {
  return <Suspense fallback={<FlowDetailPageLoading />}><MineFlowDetailPage /></Suspense>;
}

export function MinePluginsRoutePage() {
  return <Suspense fallback={<PluginsPageLoading />}><MinePluginsPage /></Suspense>;
}

export function MineTrashRoutePage() {
  return <Suspense fallback={<TrashPageLoading />}><MineTrashPage /></Suspense>;
}
